// @flow

import * as React from "react";
import { withRouter, useHistory, useParams } from "react-router-dom";
import API from "../../api/user";
import Config from "../../constants/Config";
import PurchaseLineItem from "../molecules/PurchaseLineItem";
import OrderDetailModal from "./OrderDetailModal";
import Loader from "../atoms/Loader";

const PurchaseProfileBody = ({ orders, isLoading }: any): React.Node => {
    let { id } = useParams();
    const history = useHistory();
    const [showOrderModal, setShowOrderModal] = React.useState(false);
    const [activeOrderDetails, setActiveOrderDetails] = React.useState(null);

    const selectOrderDetail = orderId => {
        setShowOrderModal(false);
        setActiveOrderDetails(null);
        history.push(
            `${Config.routes.purchases}/${orderId}${document.location.search}`
        );
    };

    const closeModal = () => {
        setShowOrderModal(false);
        setActiveOrderDetails(null);
        history.push(`${Config.routes.purchases}${document.location.search}`);
    };

    React.useEffect((): any => {
        let cancel = false;
        if (id) {
            API.userGetOrderDetails(id).then((data: any) => {
                if (!cancel) {
                    setActiveOrderDetails(data);
                    setShowOrderModal(true);
                }
            });
        }
    }, [id]);

    return (
        <div className="purchase-profile-body container-fluid">
            <div className="row">
                <div className="col-xs-12 col-md-offset-2 col-md-8">
                    <Loader active={isLoading}>
                        {orders && orders.length > 0 ? (
                            orders.map((order, key) => {
                                return (
                                    <PurchaseLineItem
                                        key={key}
                                        order={order}
                                        setActiveOrder={() =>
                                            selectOrderDetail(order.id)
                                        }
                                    />
                                );
                            })
                        ) : (
                            <div>You don't have any current purchases.</div>
                        )}
                    </Loader>
                </div>
            </div>
            {id && activeOrderDetails ? (
                <OrderDetailModal
                    onClose={() => closeModal()}
                    activeOrder={activeOrderDetails}
                    active={showOrderModal}
                />
            ) : null}
        </div>
    );
};

export default withRouter(PurchaseProfileBody);
